import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-counterpage',
  templateUrl: './counterpage.component.html',
  styleUrls: ['./counterpage.component.sass']
})
export class CounterpageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
